import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import MenuItem from "./DropdownMenu/MenuItem";
import "./Navdropdown.scss";

const Navdropdown = ({ content = [], display, name, onClose }) => {
  // 1. Build a new array where each module has only its accessible pages
  const filtered = useMemo(() => {
    return content
      .map(mod => {
        // filter pages
        const accessiblePages = Array.isArray(mod.Page)
          ? mod.Page.filter(p => p.Page_Access)
          : [];
        return { ...mod, accessiblePages };
      })
      // drop any that have neither a route nor any accessiblePages
      .filter(mod => mod.route || mod.accessiblePages.length > 0);
  }, [content]);

  // nothing to show?
  if (filtered.length === 0) return null;

  return (
    <div
      onClick={onClose}
      className={`${display ? "" : "displaynone"} maindropdown ${name}`}
    >
      {filtered.map(mod => {
        const { _id, Module_Name, route, accessiblePages } = mod;
        //  console.log( { _id, Module_Name, route, accessiblePages }, " { _id, Module_Name, route, accessiblePages }")
        // if there's a top-level route, render as a link
        if (route) {
          return (
            <NavLink key={_id} className="navLinks" to={`/${route}`}>
              <MenuItem text={Module_Name} submenu={accessiblePages} />
            </NavLink>
          );
        }

        // otherwise just render the dropdown entry
        return (
          <div key={_id} className="menuItemDiv">
            <MenuItem text={Module_Name} submenu={accessiblePages} />
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(Navdropdown);
